import { baseService } from "src/store/base.store";
import { callFunctionSafe } from "src/firebase/functions";
import { coachRecordingRepository } from "./coach-recording.repository";
import { CoachRecording } from "./types/coach-recording.entity";
import { executeQuery } from "src/store";
import { UpdateCoachApplicationAction } from "./types";

const processCoachApplication = async (requestId: string, action: UpdateCoachApplicationAction) => {
  return await callFunctionSafe<void>("processCoachApplication", {
    recordId: requestId,
    action,
  });
};

export const coachRecordingService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    updateCoachApplicationStatus: builder.mutation<void, { id: string; action: UpdateCoachApplicationAction }>({
      queryFn: async ({ id, action }) => await processCoachApplication(id, action),
      invalidatesTags: ["CoachApplication"],
    }),

    getRecordById: builder.query<CoachRecording, string>({
      queryFn: async (id: string) => await executeQuery(() => coachRecordingRepository.findById(id)),

      providesTags: ["CoachApplication"],
    }),

    getRecords: builder.query<CoachRecording[], { where: any; offset: string }>({
      queryFn: async ({ where, offset }) =>
        await executeQuery(() => coachRecordingRepository.findAll(where, offset, ["createdAt", "desc"])),

      providesTags: ["CoachApplication"],
    }),

    countRecords: builder.query<number, { where: any }>({
      queryFn: async ({ where }) => await executeQuery(() => coachRecordingRepository.count(where)),

      providesTags: ["CoachApplication"],
    }),
  }),
});

export const {
  useUpdateCoachApplicationStatusMutation,
  useGetRecordByIdQuery,
  useGetRecordsQuery,
  useCountRecordsQuery,
} = coachRecordingService;
